import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import LockClockIcon from '@mui/icons-material/LockClock';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const PunchInOutMenu = ({ closeDrawer }) => {
  const navigate = useNavigate();

  return (
    <List component="nav" disablePadding>
      <ListItemButton
        onClick={() => {
          navigate('geolocation');
          closeDrawer();
        }}
      >
        <ListItemIcon>
          <LockClockIcon color="primary" fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Punch In/Out" />
      </ListItemButton>
    </List>
  );
};

PunchInOutMenu.propTypes = {
  closeDrawer: PropTypes.func,
};

export default PunchInOutMenu;
